<div
  class="object-card-container {{ className }}"
  [class.selected]="selected"
  (click)="handleClick()"
  [class.select-mode]="selectMode"
>
  <div class="card-content">
    <div class="card-header">
      <div class="title" (click)="toggleSelect(); $event.stopPropagation()">
        <span class="object-icon">
          <fa-icon
            *ngIf="objectConfig.icon"
            [icon]="objectConfig.icon"
            [size]="'lg'"
          ></fa-icon>
        </span>
        <div
          class="check"
          *ngIf="selectable && object.can_edit"
          (click)="$event.stopPropagation()"
        >
          <sui-checkbox
            [checked]="selected"
            (checkedChange)="toggleSelect()"
          ></sui-checkbox>
        </div>
        <span [innerHTML]="objectConfig.title | highlight: filterString"></span>
      </div>
      <div class="cart-tools">
        <div class="type tool" *ngIf="object.shared_with?.length > 0">
          <fa-icon
            [icon]="['fas', 'share']"
            [suiTooltip]="sharedWithTooltip"
          ></fa-icon>
        </div>
        <div
          class="user tool"
          *ngIf="object.owner && object.owner?.avatar_url"
          [suiTooltip]="object.owner.name"
        >
          <img
            [src]="object.owner.avatar_url"
            [appFallbackImage]="avatarFallback"
            class="avatar"
          />
        </div>
        <ng-container *ngIf="canEdit">
          <!--
          <div class="cog tool" (click)="onObjectEdit($event);">
            <fa-icon [icon]="['fas', 'cog']"></fa-icon>
          </div>
          -->
          <div class="menu tool" *ngIf="hasMenu" (click)="showDropdown($event)">
            <a><fa-icon [icon]="['fas', 'bars']"></fa-icon></a>
            <div #cardDropdownContainer></div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="card-body">
      <div class="body-image">
        <div
          class="card-image"
          [style.background-image]="
            isVisible && object.thumbnail
              ? 'url(' + object.thumbnail + ')'
              : null
          "
          [class.has-image]="!!object.thumbnail"
        >
          <span class="object-icon content" *ngIf="!object.thumbnail">
            <fa-icon
              *ngIf="
                objectConfig.icon &&
                object.object_class_id != NomObjectClass.CONNECTOR
              "
              [icon]="objectConfig.icon"
              [size]="'5x'"
            ></fa-icon>

            <img
              *ngIf="
                objectConfig.image &&
                object.object_class_id === NomObjectClass.CONNECTOR
              "
              [src]="objectConfig.image"
              alt=""
            />
          </span>
        </div>
      </div>

      <div class="body-content">
        <div class="title">
          <span
            [suiTooltip]="
              object?.title.length > titleCharLimit ? object?.title : ''
            "
            [innerHTML]="
              truncateString(object?.title, titleCharLimit)
                | highlight: filterString
            "
          ></span>
        </div>
        <div
          *ngIf="object.workspace && object.workspace?.title"
          class="workspace-info"
        >
          <fa-icon [icon]="['fas', 'folder']" class="workspace-icon"></fa-icon>
          <span class="workspace-title">{{ object.workspace?.title }}</span>
        </div>
        <p
          [suiTooltip]="
            object.description.length > descriptionCharLimit
              ? object.description
              : ''
          "
          [innerHTML]="objectDescription | highlight: filterString"
          class="description"
        ></p>

        <div class="date-time-item" *ngIf="timeCreatedVisible">
          <span class="date-time-label"
            >{{ "object-card.label.created" | translate }}:</span
          >
          <span class="date-time-value">{{
            object.time_created | date: "yyyy-MM-dd HH:mm"
          }}</span>
        </div>
        <div class="date-time-item" *ngIf="timeModifiedVisible">
          <span class="date-time-label"
            >{{ "object-card.label.updated" | translate }}:</span
          >
          <span class="date-time-value">{{
            object.time_updated | date: "yyyy-MM-dd HH:mm"
          }}</span>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <div class="stats" *ngIf="statsVisible && object.stats">
        <span
          *ngIf="object.stats.feeds?.total"
          [suiTooltip]="'object-card.stats.feeds' | translate"
        >
          {{ object.stats.feeds.total }}
          <fa-icon [icon]="['fas', 'rss']"></fa-icon>
        </span>
        <span
          *ngIf="object.stats.social?.twitter?.active"
          [suiTooltip]="'object-card.stats.twitter' | translate"
        >
          {{ object.stats.social.twitter.active }}
          <fa-icon [icon]="['fab', 'twitter']"></fa-icon>
        </span>
        <span
          *ngIf="object.stats.social?.facebook"
          [suiTooltip]="'object-card.stats.facebook' | translate"
        >
          {{ object.stats.social.facebook }}
          <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
        </span>
        <span
          *ngIf="object.stats.dimensions?.total"
          [suiTooltip]="'object-card.stats.dimensions' | translate"
        >
          {{ object.stats.dimensions.total }}
          <fa-icon [icon]="['fas', 'cube']"></fa-icon>
        </span>
        <span
          *ngIf="object.stats.dashboards?.total"
          [suiTooltip]="'object-card.stats.dashboards' | translate"
        >
          {{ object.stats.dashboards.total }}
          <fa-icon [icon]="['fas', 'th-large']"></fa-icon>
        </span>
      </div>
      <div class="card-badge"></div>
    </div>
  </div>
</div>
